import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/pages/Projects'),
    },
    {
        path: '/portfolio/:id',
        name: 'project',
        component: () => import('@/pages/Project'),
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('@/pages/About'),
    },
    {
        path: '/blog',
        name: 'blog',
        component: () => import('@/pages/Blog'),
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
})

export default router
